import { useContext, useEffect } from 'react'
import { Link, withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ModalButton, TableBody, TableCell } from 'components/shared/widget'
import { useDownloadYamatoApi, useFetchTasksApi, YamatoDownloadForm } from 'api/task'
import { MaterialTaskData, Task, TaskSearchForm } from 'entities/task'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useState } from 'react'
import { Flex } from 'components/shared/flex'
import { Button, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import moment from 'moment'
import { MaterialTaskSetData, TaskSetForm } from 'entities/task_set'
import _ from 'lodash'
import { CheckboxField, DateField, SelectField } from 'components/shared/input'
import { useBulkCancelTaskSetApi, useBulkCompleteTaskSetApi } from 'api/task_set'
import { MasterDataContext } from 'contexts/master_data_context'
import { ConfirmTaskSetForm } from './material_tasks_form'

type Props = {
    history: H.History
}

export type InstitutionData = {
    institutionId?: number
    institutionName?: string
    materials?: { materialName?: string; number?: number }[]
    taskSetIds?: number[]
    isCompleted?: boolean
}

const MaterialTasksPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const masterData = useContext(MasterDataContext)
    const query = useQuery<TaskSearchForm>()
    const searchForm = useForm<TaskSearchForm>({ ...query, perPage: 100000 })
    const form = useForm<TaskSetForm>({ deliveryDate: moment(new Date()).format('YYYY-MM-DD') })
    const api = useFetchTasksApi(searchForm)
    const completeApi = useBulkCompleteTaskSetApi()
    const cancelApi = useBulkCancelTaskSetApi()
    const [tasks, setTasks] = useState<Task[]>([])
    const downloadForm = useForm<YamatoDownloadForm>({ taskGroupId: query.taskGroupId, fastest: true })
    const downloadApi = useDownloadYamatoApi()

    const [materials, setMaterials] = useState<string[]>([])
    const [institutionList, setInstitutionList] = useState<InstitutionData[]>([])
    const [showConfirm, setShowConfirm] = useState(false)
    const [selectedInstitutionData, setSelectedInstitutionData] = useState<InstitutionData>({})

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        if (api.isSuccess()) {
            setTasks(api.response.results)
        }
    }, [api.loading])

    useEffectSkipFirst(() => {
        setData()
    }, [tasks])

    const setData = () => {
        const materialItems: string[] = []
        const institutionDataList: InstitutionData[] = []
        tasks.forEach((task) => {
            const taskSetData: MaterialTaskSetData = JSON.parse(task.taskSet!.data!)
            const taskData: MaterialTaskData = JSON.parse(task.data!)
            const institutionData = institutionDataList.find((d) => d.institutionName === taskSetData.institution_name) || {}
            if (!institutionData.institutionName) {
                institutionData.institutionId = taskSetData.institution_id
                institutionData.institutionName = taskSetData.institution_name
                institutionData.taskSetIds = [task.taskSet!.id!]
                institutionDataList.push(institutionData)
                institutionData.isCompleted = true
            } else {
                institutionData.taskSetIds?.push(task.taskSet!.id!)
            }
            institutionData.taskSetIds = _.uniq(institutionData.taskSetIds)

            if (!task.completedAt) {
                institutionData.isCompleted = false
            }
            let material = institutionData.materials?.find((m) => m.materialName === taskData.material_name)
            if (material) {
                material.number! += Number(taskData.number!)
            } else {
                material = { materialName: taskData.material_name, number: taskData.number }
                if (!institutionData.materials) {
                    institutionData.materials = []
                }
                institutionData.materials.push(material!)
            }
            materialItems.push(taskData.material_name!)
        })

        setMaterials(_.uniq(materialItems))
        setInstitutionList(institutionDataList)
    }

    useEffect(() => {
        globalState.setLoading(completeApi.loading)

        if (completeApi.isSuccess()) {
            form.resetForm()
        }
    }, [completeApi.loading])

    return (
        <>
            {/* <EditTaskForm
                task={selectedTask}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            /> */}
            <ConfirmTaskSetForm
                form={form}
                institutionData={selectedInstitutionData}
                show={showConfirm}
                onClose={() => {
                    setShowConfirm(false)
                }}
                onComplete={() => {
                    completeApi.execute(form.object)
                    const newTasks = [...tasks]
                    newTasks
                        .filter((t) => selectedInstitutionData.taskSetIds?.includes(t.taskSet!.id!))
                        .forEach((t) => {
                            t.completedAt = moment().format('YYYY-MM-DD')
                        })
                    setTasks(newTasks)
                    setShowConfirm(false)
                }}
            />
            <ContentHeader
                headerTitle="資材タスク一覧"
                right={
                    <Flex>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                props.history.push(`/tasks/materials/print?taskGroupId=${query.taskGroupId}`)
                            }}
                        >
                            タスク印刷
                        </Button>
                        <ModalButton
                            openButton={<Button>ヤマトインポートシートDL</Button>}
                            modalHeader={<>ヤマトインポートシートダウンロード</>}
                            modalBody={
                                <div>
                                    {/* <SelectField
                                        form={downloadForm}
                                        attr="location"
                                        selectItems={masterData.userGroups.map((ug) => {
                                            return { label: ug.name, value: ug.name! }
                                        })}
                                        label="発送元"
                                        required
                                        includeBlank
                                    /> */}
                                    <Flex>
                                        <SelectField
                                            form={downloadForm}
                                            attr="kind"
                                            label="送り状種類"
                                            selectItems={[
                                                { value: '0', label: '発払い' },
                                                { value: '2', label: 'コレクト' },
                                                { value: '3', label: 'DM便' },
                                                { value: '4', label: 'タイム' },
                                                { value: '5', label: '着払い' },
                                                { value: '7', label: 'ネコポス' },
                                                { value: '8', label: '宅急便コンパクト' },
                                                { value: '9', label: '宅急便コンパクトコレクト' },
                                            ]}
                                            includeBlank
                                        />
                                        <DateField form={downloadForm} attr="postDate" label="出荷予定日" />
                                    </Flex>
                                    <Flex>
                                        <Flex style={{ width: '50%', height: 90 }} alignItems="center">
                                            <CheckboxField form={downloadForm} attr="fastest" checkboxLabel="最短日でお届けする" />
                                        </Flex>
                                        <div style={{ width: '50%' }}>
                                            <DateField form={downloadForm} attr="deliverDate" label="お届け予定日" disabled={downloadForm.object.fastest} />
                                        </div>
                                    </Flex>

                                    <SelectField
                                        form={downloadForm}
                                        attr="time"
                                        label="配達時間帯"
                                        selectItems={[
                                            { label: '午前中', value: '0812' },
                                            { label: '14~16時', value: '1416' },
                                            { label: '16~18時', value: '1618' },
                                            { label: '18~20時', value: '1820' },
                                            { label: '19~21時', value: '1921' },
                                            { label: '19~21時', value: '1921' },
                                            { label: '午前10時まで(DM便のみ)', value: '0010' },
                                            { label: '午後5時まで(DM便のみ)', value: '0017' },
                                        ]}
                                        includeBlank
                                        blankLabel="指定なし"
                                    />
                                </div>
                            }
                            submitButton={
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        downloadApi.execute(downloadForm)
                                    }}
                                >
                                    ダウンロード
                                </Button>
                            }
                        />
                    </Flex>
                }
            />
            <ContentBody>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ fontSize: 14 }}>用意するもの: </div>
                    <Flex flexWrap="wrap">
                        {(() => {
                            const result: Record<string, { number: number; url: string }> = {}
                            api.response.results.forEach((task) => {
                                const data: MaterialTaskData = JSON.parse(task.data || '{}')
                                if (result[data.material_name!]) {
                                    result[data.material_name!].number += Number(data.number!)
                                } else {
                                    result[data.material_name!] = { number: Number(data.number!), url: data.url! }
                                }
                            })
                            return Object.keys(result).map((materialName, index) => {
                                return (
                                    <Flex key={'aggregation-' + index} alignItems="center">
                                        <div>
                                            <a href={result[materialName].url} target="_blank" rel="noreferrer">
                                                {materialName}: {result[materialName].number}部
                                            </a>
                                            {Object.keys(result).length !== index + 1 && <span style={{ marginLeft: 10, marginRight: 2 }}>/</span>}
                                        </div>
                                    </Flex>
                                )
                            })
                        })()}
                    </Flex>
                </div>
                <Table bordered style={{ marginTop: 10, backgroundColor: '', fontSize: 10 }}>
                    <thead>
                        <tr style={{ verticalAlign: 'middle' }}>
                            <TableCell th width={50} align="center">
                                完了
                            </TableCell>
                            <TableCell th minWidth={200}>
                                施設名
                            </TableCell>
                            {materials.map((material, idx) => {
                                return (
                                    <TableCell style={{ fontSize: 12 }} th key={'material-th-' + idx} align="center" width={100}>
                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`material-name`}>{material}</Tooltip>}>
                                            <div>{material?.substring(0, 5) + (material!.length > 5 ? '...' : '')}</div>
                                        </OverlayTrigger>
                                    </TableCell>
                                )
                            })}
                        </tr>
                    </thead>
                    <TableBody columnLength={materials.length + 2} loading={api.loading}>
                        {institutionList.map((institutionData, j) => {
                            return (
                                <tr key={'institution-data-' + j} style={{ backgroundColor: institutionData.isCompleted ? '#eee' : '#fff' }}>
                                    <TableCell align="center">
                                        <input
                                            style={{ cursor: 'pointer' }}
                                            type="checkbox"
                                            readOnly
                                            onClick={() => {
                                                if (institutionData.isCompleted) {
                                                    globalState.showConfirm('取り消しますか？', () => {
                                                        cancelApi.execute({ taskSetIds: institutionData.taskSetIds! })
                                                        const newTasks = [...tasks]
                                                        newTasks
                                                            .filter((t) => institutionData.taskSetIds?.includes(t.taskSet!.id!))
                                                            .forEach((t) => {
                                                                t.completedAt = undefined
                                                            })
                                                        setTasks(newTasks)
                                                    })
                                                } else {
                                                    setSelectedInstitutionData(institutionData)
                                                    setShowConfirm(true)
                                                }
                                            }}
                                            checked={institutionData.isCompleted}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Link
                                            to={`/request_form_issuances?institutionId=${institutionData.institutionId}&institutionName=${institutionData.institutionName}`}
                                        >
                                            {institutionData.institutionName}
                                        </Link>
                                    </TableCell>
                                    {materials.map((material, idx) => {
                                        return (
                                            <TableCell key={'institution-' + j + '-material-' + idx} style={{ textAlign: 'center' }}>
                                                {(() => {
                                                    const m = institutionData.materials?.find((m) => m.materialName === material)
                                                    if (m) {
                                                        return (
                                                            <Flex alignItems="center" justifyContent="center">
                                                                {m.number}
                                                                <div style={{ transform: 'scale(70%)' }}>部</div>
                                                            </Flex>
                                                        )
                                                    } else {
                                                        return '-'
                                                    }
                                                })()}
                                            </TableCell>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </TableBody>
                </Table>
            </ContentBody>
        </>
    )
}

export default withRouter(MaterialTasksPage)
